import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ListaService } from '../../_services/lista.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Plaga } from '../../_models/plaga';
import { PlagaService } from '../../_services/plaga.service';

@Component( {
  selector: 'app-plaga-editar',
  templateUrl: 'plaga-editar.component.html'
} )

export class PlagaEditarComponent implements OnInit {
  formulario: FormGroup;
  plaga: Plaga;
  carInformacionInicial = true;
  submitted = false;
  guardando = false;
  carTabla = true;
  lisPlagas: Plaga[] = [];

  tabSeleccionado = 'PLAGA';

  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serPlaga: PlagaService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.serPlaga.obtenerPorId( params[ 'id' ] ).subscribe( plaga => {
          this.plaga = plaga;
          this.cargarInformacionInicial();
        } );
      } else {
        this.cargarInformacionInicial();
      }
    } );

  }

  cargarInformacionInicial() {

    this.formulario = this.fb.group( {
      idPlaga: [ this.plaga ? this.plaga.idPlaga : null ],
      codigo: [ this.plaga ? this.plaga.codigo : null, [ Validators.required ] ],
      nombre: [ this.plaga ? this.plaga.nombre : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.plaga ? this.plaga.indicadorHabilitado : true, [ Validators.required ] ],

    } );

    this.serPlaga.listado().subscribe( reg => {
      this.lisPlagas = reg;
      this.carTabla = false;
      this.carInformacionInicial = false;
    } );


  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {

    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const formulario = this.formulario.getRawValue();
      if ( formulario.idPlaga ) {
        if ( this.verificarNombre( formulario ) ) {
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PLAGA.MSG_ERRORNOM' )
          } );
          this.guardando = false;
          this.submitted = false;
        } else {
          /** Actualizar Proceso productivo */
          this.serPlaga.actualizar( formulario ).subscribe( plaga => {
            this.plaga = plaga;
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'INSUMOPECUARIO.MSG_REGACTU' )
            } );
            this.cambiarTabSeleccionado( 'PRODCOME' );
          } );
        }
      } else {
        if ( this.verificarCodigoYNombre( formulario ) ) {
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PLAGA.MSG_ERRORCODNOM' )
          } );
          this.guardando = false;
          this.submitted = false;
        } else {
          /** Crear Proceso productivo */
          this.serPlaga.crear( formulario ).subscribe( plaga => {
            this.plaga = plaga;
            this.f.idPlaga.setValue( this.plaga.idPlaga );
            this.f.codigo.setValue( this.plaga.codigo );
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'INSUMOPECUARIO.MSG_REGGUAR' )
            } );
            this.cambiarTabSeleccionado( 'PRODCOME' );
          } );
        }
      }
    }

  }

  verificarCodigoYNombre( item: Plaga ): boolean {
    return (this.lisPlagas.find( x => x.codigo === item.codigo || x.nombre === item.nombre )) ? true : false;
  }

  verificarNombre( item: Plaga ): boolean {
    return (this.lisPlagas.find( x => x.nombre === item.nombre && x.idPlaga !== item.idPlaga )) ? true : false;
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'PLAGA';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'PRODCOME';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'PRODUCTO';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.router.navigate( [ 'apl/plaga/' ] );
        },
        reject: () => {
        }
      } );
    } else {
      this.router.navigate( [ 'apl/plaga/' ] );
    }
  }


}
